import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "../lib/api";
import { useWishlist } from "../context/WishlistContext";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (ids.length === 0) {
      setProducts([]);
      setLoading(false);
      return;
    }
    api
      .get("/products", { params: { ids: ids.join(",") } })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [ids]);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12" data-testid="wishlist-page">
      <p className="text-xs uppercase tracking-[0.25em] text-accent font-semibold">Saved for later</p>
      <h1 className="mt-2 text-4xl text-primary font-medium">My Wishlist</h1>

      {loading ? (
        <p className="py-24 text-center text-muted-foreground">Loading…</p>
      ) : products.length === 0 ? (
        <div className="py-24 text-center" data-testid="wishlist-empty">
          <Heart size={40} className="mx-auto text-border" strokeWidth={1.2} />
          <p className="mt-4 text-muted-foreground">
            No favourites yet — tap the heart on any product to save it here.
          </p>
          <Link
            to="/shop"
            className="mt-6 inline-block bg-primary text-primary-foreground px-8 py-3 text-sm tracking-wide"
            data-testid="wishlist-shop-btn"
          >
            Explore the Shop
          </Link>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
